// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de la vista global "Gestió laboral -> Control Horari".
   Prefix "chg-": xips d'estat, cel·les de comparativa i comptadors.
   El xassís (capçalera, filtres, taula, botons) és v2 (dv2-*). */

.dv2-page.chg-page.dv2-page--fill .dv2-listBody {
  overflow-y: auto;
}

.dv2-page.chg-page.dv2-page--fill .dv2-tableWrap {
  flex: none;
  max-height: none;
}

.chg-error {
  color: var(--dv2-danger, #d9534f);
  font-weight: 700;
  margin: 0;
}

.chg-comptadors {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  flex-shrink: 0;
  padding: 10px 14px;
  background-color: var(--dv2-surface, #fff);
  border: 1px solid var(--dv2-border, #cfe0ff);
  border-radius: var(--dv2-radius, 12px);
  box-shadow: var(--dv2-shadow, none);
  font-size: 14px;
}

.chg-comptador {
  display: flex;
  align-items: center;
  gap: 5px;
}

.chg-xip-estat {
  display: inline-block;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  white-space: nowrap;
}

.chg-estat-sense {
  background-color: #9e9e9e;
}

.chg-estat-treballant {
  background-color: #0099cc;
}

.chg-estat-pausa {
  background-color: #ff9933;
}

.chg-estat-finalitzat {
  background-color: #607d8b;
}

.chg-xip {
  display: inline-block;
  font-size: 11px;
  color: #fff;
  padding: 1px 6px;
  border-radius: 10px;
  margin-right: 3px;
  white-space: nowrap;
}

.chg-xip-offline {
  background-color: #d9534f;
}

.chg-comparativa-section {
  margin-top: 8px;
  padding-top: 14px;
  border-top: 1px solid var(--dv2-border, #ddd);
}

.chg-comparativa-titol {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 700;
}

.chg-comparativa-ajuda {
  font-size: 13px;
  color: var(--dv2-text-muted, #666);
  margin: 0 0 10px;
}

.chg-comparativa-filtres {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
}

.chg-taula-comparativa th,
.chg-taula-comparativa td {
  white-space: normal;
}

.chg-cella-jornada {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
}

.chg-cella-pauses {
  color: var(--dv2-text-muted, #666);
}

.chg-desviacio-pos {
  color: #2e7d32;
  font-weight: 700;
}

.chg-desviacio-neg {
  color: #c0392b;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/gestiolaboralcontrolhorari.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,4CAA4C;EAC5C,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Estils específics de la vista global \"Gestió laboral -> Control Horari\".\n   Prefix \"chg-\": xips d'estat, cel·les de comparativa i comptadors.\n   El xassís (capçalera, filtres, taula, botons) és v2 (dv2-*). */\n\n.dv2-page.chg-page.dv2-page--fill .dv2-listBody {\n  overflow-y: auto;\n}\n\n.dv2-page.chg-page.dv2-page--fill .dv2-tableWrap {\n  flex: none;\n  max-height: none;\n}\n\n.chg-error {\n  color: var(--dv2-danger, #d9534f);\n  font-weight: 700;\n  margin: 0;\n}\n\n.chg-comptadors {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  flex-shrink: 0;\n  padding: 10px 14px;\n  background-color: var(--dv2-surface, #fff);\n  border: 1px solid var(--dv2-border, #cfe0ff);\n  border-radius: var(--dv2-radius, 12px);\n  box-shadow: var(--dv2-shadow, none);\n  font-size: 14px;\n}\n\n.chg-comptador {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.chg-xip-estat {\n  display: inline-block;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.chg-estat-sense {\n  background-color: #9e9e9e;\n}\n\n.chg-estat-treballant {\n  background-color: #0099cc;\n}\n\n.chg-estat-pausa {\n  background-color: #ff9933;\n}\n\n.chg-estat-finalitzat {\n  background-color: #607d8b;\n}\n\n.chg-xip {\n  display: inline-block;\n  font-size: 11px;\n  color: #fff;\n  padding: 1px 6px;\n  border-radius: 10px;\n  margin-right: 3px;\n  white-space: nowrap;\n}\n\n.chg-xip-offline {\n  background-color: #d9534f;\n}\n\n.chg-comparativa-section {\n  margin-top: 8px;\n  padding-top: 14px;\n  border-top: 1px solid var(--dv2-border, #ddd);\n}\n\n.chg-comparativa-titol {\n  margin: 0 0 6px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.chg-comparativa-ajuda {\n  font-size: 13px;\n  color: var(--dv2-text-muted, #666);\n  margin: 0 0 10px;\n}\n\n.chg-comparativa-filtres {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.chg-taula-comparativa th,\n.chg-taula-comparativa td {\n  white-space: normal;\n}\n\n.chg-cella-jornada {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n}\n\n.chg-cella-pauses {\n  color: var(--dv2-text-muted, #666);\n}\n\n.chg-desviacio-pos {\n  color: #2e7d32;\n  font-weight: 700;\n}\n\n.chg-desviacio-neg {\n  color: #c0392b;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
